import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Row, Col } from "react-bootstrap";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { var_api } from "../../../constant";

const QuotationMaster = () => {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 15;
const [pageLoading, setPageLoading] = useState(true);
 const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);
const [loading, setLoading] = useState(false);
  const [quotationData, setQuotationData] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [productData, setProductData] = useState([]);
  const [variantData, setVariantData] = useState([]);
  const [variantInputs, setVariantInputs] = useState([]);
  const [estimationData, setEstimationData] = useState([]);
const [estimationList, setEstimationList] = useState([]); // all estimation numbers
const [selectedEstimationId, setSelectedEstimationId] = useState(null);
const [estimationDetails, setEstimationDetails] = useState([]); // product+variant from estimation
const [showStatusModal, setShowStatusModal] = useState(false);
const [selectedRowId, setSelectedRowId] = useState(null);
const [selectedStatus, setSelectedStatus] = useState("");
const [statusLoading, setStatusLoading] = useState(false);
const [agencyData, setAgencyData] = useState([]);
const [selectedSupplier, setSelectedSupplier] = useState(null);

  const [formDataDetails, setFormDataDetails] = useState({
    product_id: "",
    variant_id: "",
  });

  // const estimation_id = localStorage.getItem("estimation_id") ;
  const supplier_id = localStorage.getItem("supplier_id") || 1;
 const userId = localStorage.getItem("user_id");
  const userName = localStorage.getItem("name");
const fetchEstimationList = async () => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_estimation/get`);
    const data = Array.isArray(res.data) ? res.data : res.data.data || [];
    setEstimationList(data);
  } catch (err) {
    console.error("Fetch Estimation List Error:", err);
    toast.error("Failed to fetch estimation list");
  }
};

const fetchEstimationData = async (estimationId) => {
  try {
    const res = await axios.get(`${var_api}sa_veemart_estimation_detail/estimation/${estimationId}`);
    const data = Array.isArray(res.data) ? res.data : res.data.data || [];
    setEstimationDetails(data);
  } catch (err) {
    console.error("Fetch Estimation Details Error:", err);
    toast.error("Failed to fetch estimation details");
  }
};

  const fetchAgencyData = async () => {
  try {
    const res = await axios.get(`${var_api}ci_veemart_supplier_master/get`);
    const agencies = Array.isArray(res.data) ? res.data : res.data.data || [];
    setAgencyData(agencies);
  } catch (err) {
    console.error("Failed to fetch suppliers:", err);
    toast.error("Failed to fetch supplier data");
  }
};

  const fetchQuotationData = async () => {
         setPageLoading(true);

    try {
      const res = await axios.get(`${var_api}sa_veemart_quotation/get`);
      const data = Array.isArray(res.data)
        ? res.data
        : res.data.data || [];
      setQuotationData(data);
    } catch (error) {
      toast.error("Failed to fetch quotations");
    }finally {
      setPageLoading(false); // stop loader
    }
  };

  // ✅ Fetch Product Data
  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_product_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setProductData(data);
    } catch {
      toast.error("Failed to fetch products");
    }
  };

  // ✅ Fetch Variant Data
  const fetchVariantData = async () => {
    try {
      const res = await axios.get(`${var_api}sa_veemart_variant_master/get`);
      const data = Array.isArray(res.data) ? res.data : res.data.data || [];
      setVariantData(data);
    } catch {
      toast.error("Failed to fetch variants");
    }
  };

  // Add Modal Open
 const handleAddClick = () => {
  setVariantInputs([]);
  setShowDetailsModal(true);
  fetchProductData();
  fetchVariantData();
  fetchEstimationList();
   fetchAgencyData(); // ✅ load suppliers
};


  // Add Variant Row
 const handleAddVariant = () => {
  if (!formDataDetails.product_id || !formDataDetails.variant_id) {
    toast.error("Please select both Product and Variant");
    return;
  }

  // Check if selected product+variant exists in estimationDetails
  const estimationRow = estimationDetails.find(
    (d) =>
      d.product_id === formDataDetails.product_id &&
      d.variant_id === formDataDetails.variant_id
  );

  // If already added, skip
  const exists = variantInputs.some(
    (v) => v.variant_id === formDataDetails.variant_id
  );
  if (exists) {
    toast.warning("Variant already added!");
    return;
  }

  // If estimation exists, use its values, else use variant defaults
  const selectedProduct = productData.find(
    (p) => p.id === formDataDetails.product_id
  );
  const selectedVariant = variantData.find(
    (v) => v.id === formDataDetails.variant_id
  );

  const newRow = {
    product_id: selectedProduct.id,
    product_name: selectedProduct.product_name,
    variant_id: selectedVariant.id,
    variant_name: selectedVariant.variant_name,
    uom: selectedVariant.uom || "-",
    gross_weight: selectedVariant.gross_weight || "-",
    net_weight: selectedVariant.net_weight || "-",
    qty: estimationRow?.qty || "",           // ✅ from estimation
    unit_price: estimationRow?.unit_price || "", 
    discount: estimationRow?.discount || "", 
    tax_percent: estimationRow?.tax_percent || "", 
    tax_amount: estimationRow?.tax_amount || "", 
    total_price: estimationRow?.total_price || "", 
    remarks: estimationRow?.remarks || "",
    available_status: estimationRow?.available_status || "",
  };

  setVariantInputs((prev) => [...prev, newRow]);
};


 
//   e.preventDefault();
//   if (variantInputs.length === 0) {
//     toast.error("Please add at least one variant!");
//     return;
//   }

//   // calculate total amount
//   const totalAmount = variantInputs.reduce(
//     (sum, item) => sum + Number(item.total_price || 0),
//     0
//   );

//   // prepare payload
//   const newQuotation = {
//     estimation_id: Number(selectedEstimationId) || Number(estimation_id),
//     supplier_id: Number(supplier_id),
//     quotation_date: new Date().toISOString().slice(0, 10),
//     added_by: Number(added_by),
//     total_amount: totalAmount.toFixed(2),
//     remarks: `Quotation generated from estimation #${localStorage.getItem("estimation_number") || "N/A"}`,
//     status: "Pending",
//     details: variantInputs.map((v) => ({
//       product_id: v.product_id,
//       variant_id: v.variant_id,
//       qty: Number(v.qty || 0),
//       gross_weight: Number(v.gross_weight || 0),
//       net_weight: Number(v.net_weight || 0),
//       unit_price: Number(v.unit_price || 0),
//       discount: Number(v.discount || 0),
//       tax_percent: Number(v.tax_percent || 0),
//       tax_amount: Number(v.tax_amount || 0),
//       total_price: Number(v.total_price || 0),
//       remarks: v.remarks || "",
//       available_status: true,
//     })),
//   };

//   try {
//     setLoading(true);
//     const res = await axios.post(`${var_api}sa_veemart_quotation/post`, newQuotation);
//     if (res.status === 200 || res.status === 201) {
//       toast.success("Quotation saved successfully!");
//       fetchQuotationData();
//       setShowDetailsModal(false);

//       // Save essentials
//       localStorage.setItem("quotation_id", res.data.id);
//       localStorage.setItem("quotation_number", res.data.quotation_number);
//       localStorage.setItem("quotation_date", newQuotation.quotation_date);
//       localStorage.setItem("added_by", newQuotation.added_by);
//       localStorage.setItem("status", newQuotation.status);

//       navigate(`/quotation-details?quotation_id=${res.data.id}`);
//     }
//   } catch (error) {
//     console.error("Quotation Save Error:", error);
//     toast.error("Failed to save quotation");
//   } finally {
//     setLoading(false);
//   }
// };

const handleResetForm = () => {
  setVariantInputs([]);
  setFormDataDetails({ product_id: "", variant_id: "" });
  setIsEditing(false);
  setEditId(null);
  toast.info("Form has been reset");
};
 useEffect(() => {
  fetchQuotationData();
  fetchAgencyData(); // ✅ also load supplier data for table display
}, []);

const handleDetailsSubmit = async (e) => {
  e.preventDefault();

  if (!selectedEstimationId) {
    toast.error("Please select an Estimation Number!");
    return;
  }
if (!selectedSupplier) {
  toast.error("Please select a supplier!");
  return;
}
if (variantInputs.length === 0) {
  toast.error("Please add at least one variant!");
  return;
}

// ✅ Validate quantity for all variants
for (const [index, item] of variantInputs.entries()) {
  const qty = parseFloat(item.qty);
  if (isNaN(qty) || qty <= 0) {
    toast.warning(`Please enter a valid quantity for row ${index + 1}`);
    return;
  }
}


  // calculate total amount
  const totalAmount = variantInputs.reduce(
    (sum, item) => sum + Number(item.total_price || 0),
    0
  );

  // prepare payload
  const newQuotation = {
    estimation_id: Number(selectedEstimationId), // ✅ selected estimation number ID
supplier_id: Number(selectedSupplier),
    // quotation_number: generateQuotationNumber(),
    quotation_date: new Date().toISOString().slice(0, 10),
    added_by: userId,
    total_amount: totalAmount.toFixed(2),
    remarks: `Quotation generated from estimation #${estimationList.find((e) => e.id === selectedEstimationId)?.estimation_number || "N/A"}`,
    status: "Pending",
    details: variantInputs.map((v) => ({
      product_id: v.product_id,
      variant_id: v.variant_id,
      qty: Number(v.qty || 0),
      gross_weight: Number(v.gross_weight || 0),
      net_weight: Number(v.net_weight || 0),
      unit_price: Number(v.unit_price || 0),
      discount: Number(v.discount || 0),
      tax_percent: Number(v.tax_percent || 0),
      tax_amount: Number(v.tax_amount || 0),
      total_price: Number(v.total_price || 0),
      remarks: v.remarks || "",
      available_status: true,
    })),
  };

  try {
    setLoading(true);
    const res = await axios.post(`${var_api}sa_veemart_quotation/post`, newQuotation);
    if (res.status === 200 || res.status === 201) {
      toast.success("Quotation saved successfully!");
      fetchQuotationData();
      setShowDetailsModal(false);

      // Save to localStorage for navigation
      localStorage.setItem("quotation_id", res.data.id);
      localStorage.setItem("quotation_number", newQuotation.quotation_number);
      localStorage.setItem("quotation_date", newQuotation.quotation_date);
      localStorage.setItem("added_by", newQuotation.added_by);
      localStorage.setItem("status", newQuotation.status);

      navigate(`/quotation-details?quotation_id=${res.data.id}`);
    }
  } catch (error) {
    console.error("Quotation Save Error:", error);
    toast.error("Failed to save quotation");
  } finally {
    setLoading(false);
  }
};
const handleStatusUpdate = async () => {
  if (!selectedStatus) {
    toast.error("Please select a status!");
    return;
  }

  try {
    setStatusLoading(true);

    const payload = {
      id: selectedRowId, // ✅ include row ID in payload
      status: selectedStatus,
    };

    const res = await axios.put(
      `${var_api}sa_veemart_quotation/update-status`,
      payload
    );

    if (res.status === 200 || res.status === 201) {
      toast.success("Status updated successfully!");
      fetchQuotationData(); // ✅ refresh table
      setShowStatusModal(false);
    }
  } catch (err) {
    console.error("Status update failed:", err);
    toast.error("Failed to update status");
  } finally {
    setStatusLoading(false);
  }
};

 const combinedOptions = productData.flatMap((product) =>
  variantData
    .filter((variant) => variant.product_id === product.id)
    .map((variant) => ({
      label: `${product.product_name} (${product.veemart_product_code || "N/A"}) - ${variant.variant_name}`,
      value: { product_id: product.id, variant_id: variant.id },
      estimation_id: variant.estimation_id || null, // include estimation link if exists
    }))
);

// Filter based on selected estimation
const filteredOptions = selectedEstimationId
  ? combinedOptions.filter((opt) => opt.estimation_id === Number(selectedEstimationId))
  : combinedOptions;


 const getStatusBadge = (status, id) => {
  switch (Number(status)) {
    case 0:
      return (
        <span
          className="badge bg-warning text-dark"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setSelectedRowId(id);
            setShowStatusModal(true);
          }}
          title="Click to update status"
        >
          Pending
        </span>
      );
    case 1:
      return <span className="badge bg-success">Approved</span>;
    case 2:
      return <span className="badge bg-danger">Rejected</span>;
    default:
      return <span className="badge bg-light text-dark">Unknown</span>;
  }
};
const getSupplierName = (id) => {
  const supplier = agencyData.find((a) => a.id === id);
  return supplier ? supplier.supplier_name : "-";
};

const filteredQuotationData = quotationData.filter((item) => {
  const query = searchQuery.toLowerCase();

  const quotationNumber = String(item?.quotation_number || "").toLowerCase();
  const quotationDate = item?.quotation_date
    ? new Date(item.quotation_date)
        .toLocaleDateString("en-GB")
        .replaceAll("/", "-")
        .toLowerCase()
    : "";
  const totalAmount = String(item?.total_amount || "").toLowerCase();
  const supplierName = String(item?.supplier_name || "").toLowerCase();

  return (
    quotationNumber.includes(query) ||
    quotationDate.includes(query) ||
    totalAmount.includes(query) ||
    supplierName.includes(query)
  );
});




  return (
    <>
      <Card>
        <Card.Body>
           {pageLoading ? (
            <div className="text-center my-5">
              <div className="spinner-border text-primary" role="status"></div>
              <div>Loading data...</div>
            </div>
          ) : (
            <>
          <div className="d-flex justify-content-end mb-3 gap-2">
              <Button
                    variant="outline-success"
                    onClick={() => navigate("/purchase-order")}
                    title="View Po"
                  >
                    <i className="fas fa-external-link-alt"></i>
                  </Button>
            <input
              type="text"
              className="form-control w-auto"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                setCurrentPage(1);
              }}
            />
            <Button variant="secondary" onClick={handleAddClick}>
              Add
            </Button>
          </div>

          <div className="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Quotation Number</th>
                  <th>Quotation Date</th>
                                <th>Supplier </th>

                  <th>Added By</th>
                  <th>Total Amount</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredQuotationData.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center text-muted">
                      No records found
                    </td>
                  </tr>
                ) : (
                  filteredQuotationData.map((item, idx) => (
                    <tr key={item.id}>
                      <td>{idx + 1}</td>
                      <td>{item.quotation_number}</td>
<td>
  {item.quotation_date
    ? new Date(item.quotation_date)
        .toLocaleDateString("en-GB")
        .replaceAll("/", "-")
    : "-"}
</td>     
 <td>{getSupplierName(item.supplier_id)}</td>
                          <td>{userName || "-"}</td>
                      <td>{item.total_amount}</td>
<td>{getStatusBadge(item.status, item.id)}</td>
                      <td>
                        <button
                          className="btn shadow btn-xs sharp"
                          style={{ backgroundColor: "#5d10e1ff", color: "white" }}
                          title="View Quotation"
                          onClick={() => {
                            localStorage.setItem("quotation_id", item.id);
                            localStorage.setItem(
                              "quotation_number",
                              item.quotation_number
                            );
                             localStorage.setItem("quotation_date", item.quotation_date);
        localStorage.setItem("added_by", item.added_by);
        localStorage.setItem("status", item.status);
                            navigate(
                              `/quotation-details?quotation_id=${encodeURIComponent(
                                item.id
                              )}`
                            );
                          }}
                        >
                          <i className="fas fa-file-invoice"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          </>
)}
        </Card.Body>
      </Card>

      {/* ✅ Quotation Modal */}
      <Modal
        show={showDetailsModal}
        onHide={() => setShowDetailsModal(false)}
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Quotation Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleDetailsSubmit}>
 

      <Row className="mb-3">
         <Col md={5}>
    <Form.Group>
      <Form.Label>Supplier</Form.Label>
      <Select
        options={agencyData.map((a) => ({
          label: a.supplier_name,
          value: a.id,
        }))}
        value={
          selectedSupplier
            ? {
                label:
                  agencyData.find((a) => a.id === selectedSupplier)?.supplier_name ||
                  "",
                value: selectedSupplier,
              }
            : null
        }
        onChange={(selected) => {
          setSelectedSupplier(selected ? selected.value : null);
        }}
        placeholder="Select Supplier"
        isClearable
        isSearchable
      />
    </Form.Group>
  </Col>
  <Col md={5}>
    <Form.Group>
      <Form.Label>Estimation Number</Form.Label>
      <Select
        options={estimationList.map((est) => ({
          label: est.estimation_number,
          value: est.id,
        }))}
        isClearable
        isSearchable
        placeholder="Select Estimation Number"
        onChange={(selected) => {
          if (selected) {
            setSelectedEstimationId(selected.value);
            fetchEstimationData(selected.value); // fetch related variants
          } else {
            setSelectedEstimationId(null);
            setEstimationDetails([]); // reset
          }
        }}
      />
    </Form.Group>
  </Col>
</Row>


            <Row className="align-items-end">
              <Col md={5}>
                <Form.Group>
                  <Form.Label>Product + Variant</Form.Label>
                <Select
  options={
    selectedEstimationId && estimationDetails.length > 0
      ? estimationDetails.map((d) => {
          const product = productData.find((p) => p.id === d.product_id);
          const variant = variantData.find((v) => v.id === d.variant_id);
          return {
            label: `${product?.product_name || "Unknown"} - ${variant?.variant_name || "Unknown"}`,
            value: { product_id: d.product_id, variant_id: d.variant_id },
          };
        })
      : productData.flatMap((product) =>
          variantData
            .filter((variant) => variant.product_id === product.id)
            .map((variant) => ({
              label: `${product.product_name} - ${variant.variant_name}`,
              value: { product_id: product.id, variant_id: variant.id },
            }))
        )
  }
  onChange={(selected) =>
    setFormDataDetails({
      product_id: selected.value.product_id,
      variant_id: selected.value.variant_id,
    })
  }
  placeholder="Select Product & Variant"
  isSearchable
/>

                </Form.Group>
              </Col>

              <Col md={2}>
                <Button
                  type="button"
                  variant="success"
                  onClick={handleAddVariant}
                >
                  <i className="fas fa-plus"></i> Add
                </Button>
              </Col>
            </Row>

            {variantInputs.length > 0 && (
              <>
           <div className="table-responsive mt-3">
  <table className="table table-bordered">
  <thead className="table-light">
  <tr>
    <th style={{ width: "4%" }}>#</th>
    <th style={{ width: "15%" }}>Product</th>
    <th style={{ width: "15%" }}>Variant</th>
    <th style={{ width: "8%" }}>UOM</th>
    <th style={{ width: "1%" }}>Gross/Net</th> {/* reduced */}
    <th style={{ width: "15%" }}>Qty</th>       {/* increased */}
    <th style={{ width: "10%" }}>Unit Price</th>
    <th style={{ width: "8%" }}>Discount</th>
    <th style={{ width: "8%" }}>Tax %</th>
    <th style={{ width: "8%" }}>Tax Amount</th>
    <th style={{ width: "10%" }}>Total Price</th>
    <th style={{ width: "12%" }}>Remarks</th>
  </tr>
</thead>

    <tbody>
      {variantInputs.map((v, idx) => (
        <tr key={idx}>
          <td>{idx + 1}</td>
          <td>{v.product_name}</td>
          <td>{v.variant_name}</td>
          <td>{v.uom}</td>
          <td>
            {v.gross_weight}/{v.net_weight}
          </td>

          {/* Qty */}
          <td>
            <Form.Control
              type="number"
              min="0"
              value={v.qty}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].qty = e.target.value;

                  // auto-calculate total price when qty changes
                  const unitPrice = Number(updated[idx].unit_price || 0);
                  const discount = Number(updated[idx].discount || 0);
                  const tax = Number(updated[idx].tax_percent || 0);

                  const subtotal = unitPrice * Number(e.target.value || 0);
                  const afterDiscount = subtotal - (subtotal * discount) / 100;
                  const taxAmount = (afterDiscount * tax) / 100;
                  updated[idx].tax_amount = taxAmount.toFixed(2);
                  updated[idx].total_price = (afterDiscount + taxAmount).toFixed(2);

                  return updated;
                })
              }
            />
          </td>

          {/* Unit Price */}
          <td>
            <Form.Control
              type="number"
              min="0"
              value={v.unit_price || ""}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].unit_price = e.target.value;

                  // recalc total
                  const qty = Number(updated[idx].qty || 0);
                  const discount = Number(updated[idx].discount || 0);
                  const tax = Number(updated[idx].tax_percent || 0);
                  const subtotal = qty * Number(e.target.value || 0);
                  const afterDiscount = subtotal - (subtotal * discount) / 100;
                  const taxAmount = (afterDiscount * tax) / 100;
                  updated[idx].tax_amount = taxAmount.toFixed(2);
                  updated[idx].total_price = (afterDiscount + taxAmount).toFixed(2);

                  return updated;
                })
              }
            />
          </td>

          {/* Discount */}
          <td>
            <Form.Control
              type="number"
              min="0"
              value={v.discount || ""}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].discount = e.target.value;

                  const qty = Number(updated[idx].qty || 0);
                  const unitPrice = Number(updated[idx].unit_price || 0);
                  const tax = Number(updated[idx].tax_percent || 0);
                  const subtotal = qty * unitPrice;
                  const afterDiscount = subtotal - (subtotal * Number(e.target.value || 0)) / 100;
                  const taxAmount = (afterDiscount * tax) / 100;
                  updated[idx].tax_amount = taxAmount.toFixed(2);
                  updated[idx].total_price = (afterDiscount + taxAmount).toFixed(2);

                  return updated;
                })
              }
            />
          </td>

          {/* Tax % */}
          <td>
            <Form.Control
              type="number"
              min="0"
              value={v.tax_percent || ""}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].tax_percent = e.target.value;

                  const qty = Number(updated[idx].qty || 0);
                  const unitPrice = Number(updated[idx].unit_price || 0);
                  const discount = Number(updated[idx].discount || 0);
                  const subtotal = qty * unitPrice;
                  const afterDiscount = subtotal - (subtotal * discount) / 100;
                  const taxAmount = (afterDiscount * Number(e.target.value || 0)) / 100;
                  updated[idx].tax_amount = taxAmount.toFixed(2);
                  updated[idx].total_price = (afterDiscount + taxAmount).toFixed(2);

                  return updated;
                })
              }
            />
          </td>

          {/* Tax Amount (auto) */}
          <td>
            <Form.Control
              type="text"
              value={v.tax_amount || "0.00"}
              readOnly
              disabled
            />
          </td>

          {/* Total Price (auto) */}
          <td>
            <Form.Control
              type="text"
              value={v.total_price || "0.00"}
              readOnly
              disabled
            />
          </td>

          {/* Remarks */}
          <td>
            <Form.Control
              type="text"
              value={v.remarks}
              onChange={(e) =>
                setVariantInputs((prev) => {
                  const updated = [...prev];
                  updated[idx].remarks = e.target.value;
                  return updated;
                })
              }
            />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>


                              <div className="d-flex justify-content-end gap-2 mt-3">
                 <Button type="submit" variant="secondary" disabled={loading}>
                   {loading ? (
                     <>
                       <span
                         className="spinner-border spinner-border-sm me-2"
                         role="status"
                         aria-hidden="true"
                       ></span>
                       {isEditing ? "Updating..." : "Submitting..."}
                     </>
                   ) : (
                     isEditing ? "Update" : "Submit"
                   )}
                 </Button>
               
                 <Button variant="warning" type="button" onClick={handleResetForm} disabled={loading}>
                   <i className="fas fa-undo"></i> Reset
                 </Button>
               
                 <Button variant="danger" onClick={() => setShowDetailsModal(false)} disabled={loading}>
                   Cancel
                 </Button>
               </div>
              </>
            )}
          </Form>
        </Modal.Body>
      </Modal>
<Modal
  show={showStatusModal}
  onHide={() => setShowStatusModal(false)}
  centered
>
  <Modal.Header closeButton>
    <Modal.Title>Update Quotation Status</Modal.Title>
  </Modal.Header>

  <Modal.Body>
    <Form>
      <Form.Group>
        <Form.Label>Select New Status</Form.Label>
        <div className="d-flex flex-column mt-2">
          <Form.Check
            type="radio"
            label="Approved"
            name="quotationStatus"
            value="1"
            checked={selectedStatus === "1"}
            onChange={(e) => setSelectedStatus(e.target.value)}
          />
          <Form.Check
            type="radio"
            label="Rejected"
            name="quotationStatus"
            value="2"
            checked={selectedStatus === "2"}
            onChange={(e) => setSelectedStatus(e.target.value)}
          />
        </div>
      </Form.Group>
    </Form>
  </Modal.Body>

  <Modal.Footer>
   
    <Button
      variant="warning"
      onClick={handleStatusUpdate}
      disabled={statusLoading}
    >
      {statusLoading ? (
        <>
          <span
            className="spinner-border spinner-border-sm me-2"
            role="status"
          ></span>
          Updating...
        </>
      ) : (
        "Update"
      )}
    </Button>
     <Button
      variant="danger"
      onClick={() => setShowStatusModal(false)}
      disabled={statusLoading}
    >
      Cancel
    </Button>
  </Modal.Footer>
</Modal>


      <ToastContainer />
    </>
  );
};

export default QuotationMaster;
